import $ from "jquery";
let config;
export default (function() {
  function CartService() {}

  var cartStorageKey = "cart-storage";
  var checkoutUrlKey = "checkoutUrl";
  var orderIdKey = "order-id";

  CartService.prototype.save = function(cart) {
    sessionStorage.setItem(cartStorageKey, JSON.stringify(cart));
  };

  CartService.prototype.get = function() {
    return JSON.parse(sessionStorage.getItem(cartStorageKey));
  };

  CartService.prototype.cancelCheckout = function() {
    sessionStorage.removeItem(checkoutUrlKey);
  };

  CartService.prototype.clearState = function() {
    sessionStorage.removeItem(cartStorageKey);
    sessionStorage.removeItem(checkoutUrlKey);
    sessionStorage.removeItem(orderIdKey);
  };

  CartService.prototype.addToCart = function(item) {
    let items = this.getCartItems();
    items.push(item);
    sessionStorage.setItem(cartStorageKey, JSON.stringify(items));
    return items;
  };

  CartService.prototype.addItemQuantity = function(index, quantity) {
    let items = this.getCartItems();
    if (items.length - 1 < index) {
      return;
    }

    items[index].quantity += quantity;
    sessionStorage.setItem(cartStorageKey, JSON.stringify(items));
    return items;
  };

  CartService.prototype.clearCart = function() {
    this.clearState();
  };

  CartService.prototype.getCartItems = function() {
    return JSON.parse(sessionStorage.getItem(cartStorageKey)) || [];
  };

  CartService.prototype.removeFromCart = function(index) {
    let cartItems = this.getCartItems();
    cartItems.splice(index, 1);
    sessionStorage.setItem(cartStorageKey, JSON.stringify(cartItems));
    sessionStorage.removeItem(checkoutUrlKey);
    return cartItems;
  };

  CartService.prototype.setItemQuantity = function(productKey, quantity) {
    var cartItems = this.getCartItems();
    if (!quantity) {
      // remove all
      delete cartItems[productKey];
    } else if (cartItems.hasOwnProperty(productKey)) {
      cartItems[productKey].quantity = quantity;
    }
    sessionStorage.setItem(cartStorageKey, JSON.stringify(cartItems));
    sessionStorage.removeItem(checkoutUrlKey);
    return cartItems;
  };

  CartService.prototype.getTotal = function() {
    var cartItems = this.getCartItems();
    return cartItems.map(item => {
      return item.quantity * item.price;
    });

    // var productKeys = Object.keys(cartItems)
    // var amounts = productKeys.map(function (productKey) {
    //   return cartItems[productKey].product.price * cartItems[productKey].quantity
    //     + cartItems[productKey].giftWrapped === true
    // })

    // var total = 0
    // amounts.forEach(function (amount) {
    //   total += amount
    // })

    // return total
  };

  CartService.prototype.createOrder = function(firebaseUserIdToken, order) {
    var cartItems = this.getCartItems();
    return new Promise(function(resolve, reject) {
      var productKeys = Object.keys(cartItems);
      var cart = {};
      productKeys.forEach(function(productKey) {
        cart[productKey] = {
          giftWrapped: cartItems[productKey].giftWrapped,
          quantity: cartItems[productKey].quantity
        };
      });

      var discounts;
      if (order.discounts.length) {
        discounts = {};
        order.discounts.forEach(function(discount) {
          discounts[discount.key] = discount.value;
        });
      }

      var deliveryAddress = order.deliveryAddress.id
        ? { id: order.deliveryAddress.id }
        : order.deliveryAddress;

      var orderId = order.key;
      var url = orderId
        ? `${config.API_URL}/orders/${orderId}`
        : `${config.API_URL}/orders`;
      var method = orderId ? "PUT" : "POST";

      $.ajax({
        url: url,
        method: method,
        headers: {
          Authorization: "Bearer " + firebaseUserIdToken,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          cart: cart,
          deliveryAddress: deliveryAddress,
          specialInstructions: order.specialInstructions,
          discounts: discounts,
          contactNumber: order.contactNumber
        }),
        success: function(data) {
          sessionStorage.setItem(orderIdKey, data.id);
          sessionStorage.setItem(checkoutUrlKey, data.checkoutUrl);
          resolve(data);
        },
        error: function(jqXHR, error) {
          reject(
            new Error(
              "Sorry, an error occurred while processing your order. Please contact the administrators if the problem persists"
            )
          );
        }
      });
    });
  };

  CartService.prototype.getActiveCheckout = function() {
    return sessionStorage.getItem(checkoutUrlKey);
  };

  return new CartService();
})();



// WEBPACK FOOTER //
// ./src/assets/js/cart-service.js